"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class ResponseError extends Error {
  constructor(statusCode, message, requestUrl, resBody = {}) {
    super(message);
    this.status = statusCode;
    this.message = message;
    this.requestUrl = requestUrl;
    this.name = this.constructor.name;
    this.response = resBody;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
var _default = ResponseError;
exports.default = _default;